import { Middleware } from "redux";
import { RootState } from "../../../state";
import { serverRequest } from "../../../actions/app/api";
import { APP_URL, POST } from "../../../../_shared/constants";
import { CREATE_WHITELIST } from "../../../actions";

export const createWhitelist: Middleware<unknown, RootState> =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    next(action);
    if (action.type === CREATE_WHITELIST.START) {
      const { payload, onFinish, ...rest } = action.meta;
      dispatch(
        serverRequest({
          method: POST,
          url: `${APP_URL.whitelist.create}`,
          onFinish,
          payload,
          onSuccess: CREATE_WHITELIST.SUCCESS,
          ...rest,
        })
      );
    }
  };
